<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card">
                    <div class="card-header"><span id="titlista">FILTROS DO DEMONSTRATIVO DE RESULTADOS</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div> 
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-4">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="plstfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>          
                            <div class="col-md-1" style="padding-top: 20px;" >
                                <button type="button" @click.prevent="mtdbuscarfiliais()" title="Importar minhas filiais" class="btn btn-primary btn-sm btn-block"><i class="fa fa-reply" aria-hidden="true"></i></button>
                            </div>                  
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">Conta:</span>
                                <select id="cbconta" data-placeholder="Selecione uma opção"
                                    v-model="pidconta" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Grupo de conta:</span>
                                <select id="cbgrupoconta" data-placeholder="Selecione uma opção"
                                    v-model="pidgrupoconta" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Centro de custo:</span>
                                <select id="cbcentrocusto" data-placeholder="Selecione uma opção"
                                    v-model="pidcentrocusto" 
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div> 
                            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2" style="padding-top: 22px;">                            
                                <div class="custom-control custom-switch border rounded" style="margin-top: -2px;padding: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbdetalhartodos" v-model="pdetalhartodos" @change="mtddetalhartodos()">
                                    <label class="custom-control-label" for="cbdetalhartodos" id="lbldetalhartodos" style="margin-left: 40px;">Detalhar todos</label>
                                </div>
                            </div> 
                            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2" style="padding-top: 22px;">                            
                                <div class="custom-control custom-switch border rounded" style="margin-top: -2px;padding: 5px;">
                                    <input type="checkbox" @change="mtdlimparlistagem()" class="custom-control-input" id="cbdetalharfilial" v-model="pdetalharfilial" >
                                    <label class="custom-control-label" for="cbdetalharfilial" id="lbldetalharfilial" style="margin-left: 40px;">Detalhar filial</label>
                                </div>
                            </div> 
                            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2" style="padding-top: 22px;">                            
                                <!-- <div class="custom-control custom-switch border rounded" style="margin-top: -2px;padding: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbexibegrafico" v-model="pexibegrafico" @change="mtdexecutadash()">
                                    <label class="custom-control-label" for="cbexibegrafico" id="lbexibegrafico" style="margin-left: 40px;">Exibir gráfico</label>
                                </div> -->
                            </div>                                                                                                                                           
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <!-- <button type="button" id="btimprimir" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdimprimir()" style="margin-top: 20px;"><i class="fa fa-print"></i> Imprimir</button> -->
                           
                                <div class="dropdown" style="padding-top: 20px;">
                                    <button type="button" id="btimprimir" class="btn btn-secondary btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                        <i class="fa fa-navicon"></i> Exportar
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="mtdimprimir(false)"><i class="fa fa-print"></i> Imprimir</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdimprimir(true)"><i class="fa fa-file-excel-o"></i> Excel</a>																			
                                    </div>
                                </div>	
                           
                            </div>                            
                        </div>
                    </div>                                                              
                </div>

                <div v-show="pexibegrafico" class="card" style="margin-top: 10px; padding: 15px; padding-bottom: 0px; margin-bottom: 15px;">
                    <div class="card-header card-dash">
                        <span class="tit-card-dash">Balanço por filial</span>
                    </div>
                    <div class="card-body" style="padding-bottom: 10px;">
                        <div class="row">
                            <div class="col-md-12 grafico-line"  style="margin-top: -40px;">
                                <graficobarraagrupada v-bind:agrupamento = "vagrupamento" v-bind:series = "vseries"

                                ></graficobarraagrupada>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="lstreceitas.length > 0 || lstdespesas.length > 0 || lstdadosfiliais.length > 0" class="card" style="margin-top: 10px; padding: 15px; padding-bottom: 0px; margin-bottom: 15px;">
                    <div v-show="!pdetalharfilial">
                        <div v-if="lstreceitas.length > 0 || lstdespesas.length > 0" class="row">     
                              <div class="col-sm-12 table-responsive" style="padding-bottom: 0px;">
                                <table class="table table-hover table-sm table-dre responsive">
                                    <tbody>
                                        <tr>
                                            <td colspan="5" class="font-weight-bold text-black-50" style="vertical-align: top;">
                                                <i class="fa fa-info-circle text-info"></i>
                                                itens marcados com (<i class="fa fa-check-square"></i>) participam do totalizadores
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                              </div>
                        
                            <div class="col-sm-12 table-responsive" style="padding-bottom: 0px;">
                                <table id="tbreceitas" class="table table-hover table-sm table-dre responsive">
                                    <tbody>
                                        <tr v-for="(receita, index) in lstreceitas" v-bind:key="index">
                                            <td class="font-weight-bold text-black-50" style="vertical-align: top;">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <i style="padding-right: 22px;" :class="parseInt(receita.marcado) === 0 ? 'fa fa-square' : 'fa fa-check-square' " @click.prevent="mtdmarcadesmarcagrupo(lstreceitas, index);"></i><i class="fa fa-plus-circle receitas" @click.prevent="mtddetalheitem(lstreceitas, index);"></i> {{receita.descgruconta}}
                                                    </div>
                                                    <template v-if="parseInt(receita.detalhar) === 1">
                                                        <div class="col-md-2"></div>
                                                        <div class="col-md-10">
                                                            <div class="table-responsive table-borderless">
                                                                <table class="table table-hover table-sm table-dreresponsive">
                                                                    <tbody>
                                                                        <tr v-for="(movimento, indmov) in receita.movimentos" title="Clique para ver os lançamentos." v-bind:key="indmov">
                                                                            <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left; font-size: 12px; padding-top: 3px; padding-bottom: 3px;'><span  @click.prevent="mtddetalhalancamentos(movimento)" style="padding-right: 8px; cursor: pointer;"><i class="fa fa-external-link"></i> </span>{{movimento.descplano}}</td>
                                                                            <td class="font-weight-bold text-right receitas" style='font-size: 12px; padding-top: 3px; padding-bottom: 3px;'>{{mtdformatavalordecimal(movimento.totalmov, 2)}}</td>
                                                                            <td width="50" v-if="parseInt(movimento.marcado) === 1" class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;">{{mtdformatavalordecimal(movimento.totalmov / receita.totalmov * 100, 2)}}%</td>
                                                                            <td width="50" v-else class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;"></td>
                                                                            <td width="50" class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;"><i :class="parseInt(movimento.marcado) === 0 ? 'fa fa-square' : 'fa fa-check-square' " @click.prevent="mtdmarcadesmarcamovimento(receita.movimentos, indmov);"></i></td>
                                                                        </tr> 
                                                                    </tbody>
                                                                </table>
                                                            </div>                                
                                                        </div>
                                                    </template>
                                                </div>                                       
                                            </td>
                                            <td class="text-right text-receitas font-weight-bold" style="vertical-align: top;">{{mtdformatavalordecimal(receita.totalmov, 2)}}</td>                            
                                            <td width="50" class="text-right text-black-50" style="font-size: 12px; vertical-align: top;">{{mtdformatavalordecimal(receita.totalmov / totalreceitas * 100, 2)}}%</td>
                                        </tr>                        
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-sm-12 table-responsive">
                                <table class="table table-hover table-sm table-dre responsive">
                                    <tbody>
                                        <tr v-for="(despesa, index) in lstdespesas" v-bind:key="index">
                                            <td class="font-weight-bold text-black-50">
                                                <div class="row">
                                                    <div class="col-md-12">                                    
                                                        <i style="padding-right: 22px;" :class="parseInt(despesa.marcado) === 0 ? 'fa fa-square' : 'fa fa-check-square' " @click.prevent="mtdmarcadesmarcagrupo(lstdespesas, index);"></i><i class="fa fa-minus-circle despesas" @click.prevent="mtddetalheitem(lstdespesas, index);"></i> {{despesa.descgruconta}}
                                                    </div>
                                                    <template v-if="parseInt(despesa.detalhar) === 1">
                                                        <div class="col-md-2"></div>
                                                        <div class="col-md-10">
                                                            <div class="table-responsive table-borderless">
                                                                <table class="table table-hover table-sm table-dre responsive">
                                                                    <tbody>
                                                                        <tr v-for="(movimento, indmov) in despesa.movimentos"  v-bind:key="indmov">
                                                                            <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left; font-size: 12px; padding-top: 3px; padding-bottom: 3px;'><span @click.prevent="mtddetalhalancamentos(movimento)" style="padding-right: 8px; cursor: pointer;"><i class="fa fa-external-link"></i> </span>{{movimento.descplano}}</td>
                                                                            <td class="font-weight-bold text-right despesas" style='font-size: 12px; padding-top: 3px; padding-bottom: 3px;'>{{mtdformatavalordecimal(movimento.totalmov, 2)}}</td>
                                                                            <td v-if="parseInt(movimento.marcado) === 1" width="50" class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;">{{mtdformatavalordecimal(movimento.totalmov / despesa.totalmov * 100, 2)}}%</td>
                                                                            <td v-else width="50" class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;"></td>
                                                                            <td width="50" class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;"><i :class="parseInt(movimento.marcado) === 0 ? 'fa fa-square' : 'fa fa-check-square' " @click.prevent="mtdmarcadesmarcamovimento(despesa.movimentos, indmov);"></i></td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>                                
                                                        </div>
                                                    </template>                                        
                                                </div>                                        
                                            </td>
                                            <td class="text-right text-despesas font-weight-bold" style="vertical-align: top;">{{mtdformatavalordecimal(despesa.totalmov, 2)}}</td>
                                            <td width="50" class="text-right text-black-50" style="font-size: 12px; vertical-align: top;">{{mtdformatavalordecimal(despesa.totalmov / totaldespesas * 100, 2)}}%</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div> 
                        </div>
                        <div v-if="lstreceitas.length > 0 || lstdespesas.length > 0" class="row border-top" style="padding-top: 10px;">
                            <div class="col-md-3"></div>
                            <div class="col-md-6 table-responsive" style="padding-bottom: 0px;">
                                <table class="table table-borderless table-hover table-sm table-dre responsive">
                                    <tbody>
                                    <tr>
                                        <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left;'><i class="fa fa-plus-circle text-receitas"></i> TOTAL RECEITAS</td>
                                        <td class="text-right text-receitas font-weight-bold">{{mtdformatavalordecimal(totalreceitas, 2)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left;'><i class="fa fa-minus-circle text-despesas"></i> TOTAL DESPESAS</td>
                                        <td class="text-right text-despesas font-weight-bold border-bottom">{{mtdformatavalordecimal(totaldespesas, 2)}}</td>
                                    </tr>                        
                                    <tr>
                                        <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left;'><i class="fa fa-arrow-circle-right"></i> TOTAL LÍQUIDO DO EXERCÍCIO</td>
                                        <td class="text-right font-weight-bold" v-bind:class="parseFloat(totaldif) > 0 ? 'text-receitas' : 'text-despesas'">{{mtdformatavalordecimal(totaldif, 2)}}</td>
                                    </tr>                                                
                                    </tbody>
                                </table>
                            </div>                
                            <div class="col-md-3"></div>
                        </div> 
                    </div>

                    <!-- aqui é o detalhado por filial -->
                    <div v-show="pdetalharfilial">
                        <div v-for="(filial, indexfil) in lstdadosfiliais" v-bind:key="indexfil" class="row">    
                            <div class="col-12">
                                <div style="width: 100%;" class="card">
                                    <div class="card-head">
                                        <h6 style="padding-left: 15px; padding-top: 15px;"><i style="padding-right: 22px;" :class="parseInt(filial.marcado) === 0 ? 'fa fa-square' : 'fa fa-check-square' " @click.prevent="mtdmarcadesmarcafilial(lstdadosfiliais, indexfil);"></i>{{filial.fantasia}}</h6>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div  class="col-sm-12 table-responsive" style="padding-bottom: 0px;">
                                                <table id="tbreceitas" class="table table-hover table-sm table-dre responsive">
                                                    <tbody>
                                                        <tr v-for="(receita, index) in filial.receitas" v-bind:key="index">
                                                            <td class="font-weight-bold text-black-50" style="vertical-align: top;">
                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <i style="padding-right: 22px;" :class="parseInt(receita.marcado) === 0 ? 'fa fa-square' : 'fa fa-check-square' " @click.prevent="mtdmarcadesmarcagrupo(filial.receitas, index);"></i><i class="fa fa-plus-circle receitas" @click.prevent="mtddetalheitem(filial.receitas, index);"></i> {{receita.descgruconta}}
                                                                    </div>
                                                                    <template v-if="parseInt(receita.detalhar) === 1">
                                                                        <div class="col-md-2"></div>
                                                                        <div class="col-md-10">
                                                                            <div class="table-responsive table-borderless">
                                                                                <table class="table table-hover table-sm table-dreresponsive">
                                                                                    <tbody>
                                                                                        <tr v-for="(movimento, indmov) in receita.movimentos"  v-bind:key="indmov">
                                                                                            <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left; font-size: 12px; padding-top: 3px; padding-bottom: 3px;'><span @click.prevent="mtddetalhalancamentosfil(movimento, filial)" style="padding-right: 8px; cursor: pointer;"><i class="fa fa-external-link"></i> </span>{{movimento.descplano}}</td>
                                                                                            <td class="font-weight-bold text-right receitas" style='font-size: 12px; padding-top: 3px; padding-bottom: 3px;'>{{mtdformatavalordecimal(movimento.totalmov, 2)}}</td>
                                                                                            <td width="50" v-if="parseInt(movimento.marcado) === 1" class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;">{{mtdformatavalordecimal(movimento.totalmov / receita.totalmov * 100, 2)}}%</td>
                                                                                            <td width="50" v-else class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;"></td>
                                                                                            <td width="50" class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;"><i :class="parseInt(movimento.marcado) === 0 ? 'fa fa-square' : 'fa fa-check-square' " @click.prevent="mtdmarcadesmarcamovimento(receita.movimentos, indmov);"></i></td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>                                
                                                                        </div>
                                                                    </template>
                                                                </div>                                       
                                                            </td>
                                                            <td class="text-right text-receitas font-weight-bold" style="vertical-align: top;">{{mtdformatavalordecimal(receita.totalmov, 2)}}</td>                            
                                                            <td width="50" class="text-right text-black-50" style="font-size: 12px; vertical-align: top;">{{mtdformatavalordecimal(receita.totalmov / filial.totalreceitas * 100, 2)}}%</td>
                                                        </tr>                        
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div class="col-sm-12 table-responsive">
                                                <table class="table table-hover table-sm table-dre responsive">
                                                    <tbody>
                                                        <tr v-for="(despesa, index) in filial.despesas" v-bind:key="index">
                                                            <td class="font-weight-bold text-black-50">
                                                                <div class="row">
                                                                    <div class="col-md-12">                                    
                                                                        <i style="padding-right: 22px;" :class="parseInt(despesa.marcado) === 0 ? 'fa fa-square' : 'fa fa-check-square' " @click.prevent="mtdmarcadesmarcagrupo(filial.despesas, index);"></i><i class="fa fa-minus-circle despesas" @click.prevent="mtddetalheitem(filial.despesas, index);"></i> {{despesa.descgruconta}}
                                                                    </div>
                                                                    <template v-if="parseInt(despesa.detalhar) === 1">
                                                                        <div class="col-md-2"></div>
                                                                        <div class="col-md-10">
                                                                            <div class="table-responsive table-borderless">
                                                                                <table class="table table-hover table-sm table-dre responsive">
                                                                                    <tbody>
                                                                                        <tr v-for="(movimento, indmov) in despesa.movimentos"  v-bind:key="indmov">
                                                                                            <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left; font-size: 12px; padding-top: 3px; padding-bottom: 3px;'><span @click.prevent="mtddetalhalancamentosfil(movimento, filial)" style="padding-right: 8px; cursor: pointer;"><i class="fa fa-external-link"></i> </span>{{movimento.descplano}}</td>
                                                                                            <td class="font-weight-bold text-right despesas" style='font-size: 12px; padding-top: 3px; padding-bottom: 3px;'>{{mtdformatavalordecimal(movimento.totalmov, 2)}}</td>
                                                                                            <td width="50" v-if="parseInt(movimento.marcado) === 1" class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;">{{mtdformatavalordecimal(movimento.totalmov / despesa.totalmov * 100, 2)}}%</td>
                                                                                            <td width="50" v-else class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;"></td>
                                                                                            <td width="50" class="text-right text-black-50" style="font-size: 12px; padding-top: 3px; padding-bottom: 3px;"><i :class="parseInt(movimento.marcado) === 0 ? 'fa fa-square' : 'fa fa-check-square' " @click.prevent="mtdmarcadesmarcamovimento(despesa.movimentos, indmov);"></i></td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>                                
                                                                        </div>
                                                                    </template>                                        
                                                                </div>                                        
                                                            </td>
                                                            <td class="text-right text-despesas font-weight-bold" style="vertical-align: top;">{{mtdformatavalordecimal(despesa.totalmov, 2)}}</td>
                                                            <td width="50" class="text-right text-black-50" style="font-size: 12px; vertical-align: top;">{{mtdformatavalordecimal(despesa.totalmov / filial.totaldespesas * 100, 2)}}%</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div> 
                                        </div>
                                    </div>
                                </div> 
                            </div>      
                        </div>
                        <div v-if="lstdadosfiliais.length > 0 " class="row border-top" style="padding-top: 10px;">
                            <div class="col-md-3"></div>
                            <div class="col-md-6 table-responsive" style="padding-bottom: 0px;">
                                <!-- receitas por filial -->
                                <table class="table table-borderless table-hover table-sm table-dre responsive">
                                    <tbody>
                                        <tr v-for="(filireceita, index) in lstdadosfiliais" v-bind:key="index">
                                            <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left;'><i class="fa fa-plus-circle text-receitas"></i> {{filireceita.fantasia}}</td>
                                            <td class="text-right text-receitas font-weight-bold">{{mtdformatavalordecimal(filireceita.totalreceitas, 2)}}</td>
                                        </tr>                                        
                                    </tbody>
                                </table>

                                <!-- despesas por filial -->
                                <table class="table table-borderless table-hover table-sm table-dre responsive">
                                    <tbody>
                                        <tr v-for="(filidespesa, index) in lstdadosfiliais" v-bind:key="index">
                                            <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left;'><i class="fa fa-minus-circle text-despesas"></i> {{filidespesa.fantasia}}</td>
                                            <td class="text-right text-despesas font-weight-bold border-bottom">{{mtdformatavalordecimal(filidespesa.totaldespesas, 2)}}</td>
                                        </tr>                                                                    
                                    </tbody>
                                </table>
                            </div>                
                            <div class="col-md-3"></div>
                        </div>
                        <div v-if="lstdadosfiliais.length > 0" class="row border-top" style="padding-top: 10px;">
                            <div class="col-md-3"></div>
                            <div class="col-md-6 table-responsive" style="padding-bottom: 0px;">
                                <table class="table table-borderless table-hover table-sm table-dre responsive">
                                    <tbody>
                                    <tr>
                                        <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left;'><i class="fa fa-plus-circle text-receitas"></i> TOTAL RECEITAS</td>
                                        <td class="text-right text-receitas font-weight-bold">{{mtdformatavalordecimal(totalreceitas, 2)}}</td>
                                    </tr>
                                    <tr>
                                        <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left;'><i class="fa fa-minus-circle text-despesas"></i> TOTAL DESPESAS</td>
                                        <td class="text-right text-despesas font-weight-bold border-bottom">{{mtdformatavalordecimal(totaldespesas, 2)}}</td>
                                    </tr>                        
                                    <tr>
                                        <td class="font-weight-bold text-black-50" style='vertical-align: middle; text-align: left;'><i class="fa fa-arrow-circle-right"></i> TOTAL LÍQUIDO DO EXERCÍCIO</td>
                                        <td class="text-right font-weight-bold" v-bind:class="parseFloat(totaldif) > 0 ? 'text-receitas' : 'text-despesas'">{{mtdformatavalordecimal(totaldif, 2)}}</td>
                                    </tr>                                                
                                    </tbody>
                                </table>
                            </div>                
                            <div class="col-md-3"></div>
                        </div>  
                    </div>
                </div>
            </div>                
        </div>
        <!-- Modal para definição do período para a dashboard -->
        <div class="modal fade" id="mdincluirfilial" tabindex="-1" role="dialog"
            aria-labelledby="adicionarfilial" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="adicionarfilial"><i></i> Incluir filiais no demonstrativo
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro">
                                    <option value="0">Código</option>
                                    <option value="1">Razão Social</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-10 col-lg-10">
                                <label for="edfilialpesq">Filial:</label>
                                <input type="text" v-model="vfilialpesq"
                                        class="form-control form-control-sm" id="edfilialpesq">
                            </div>
                        </div>
                        <div class="col-lg-12" style="height: 200px; overflow-y: auto;">
                            <div class="table-responsive">
                                <table id="tblistatabelasatribuidas"
                                        class="table table-bordered table-sm table-hover"
                                        style="margin-top: 10px">
                                    <thead class="thead-light">
                                        <tr>
                                            <th width="5px" style="text-align: center;"></th>
                                            <th>Id</th>
                                            <th>Filial</th>
                                        </tr>
                                    </thead>
                                    <tbody id="lstfiliaisadicionar">
                                        <tr v-for="(filial, index) in lstfiliaisFiltradas" :key="index">
                                            <td class="text-center">
                                                <input type="checkbox" v-model="filial.selecionado">
                                            </td>
                                            <td>{{ filial.codfil }}</td>
                                            <td>{{ filial.fantasia }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button"  @click.prevent="mtdadicionafiliais()" class="btn btn-primary btn-sm"><i class="fa fa-check" aria-hidden="true"></i> Adicionar filiais </button>
                    </div>
                </div>
            </div>
        </div>     
    </div>   
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import Graficobarraagrupada from '../components/cmpgraficobarraagrupada.vue'
    import util from '../utilitarios/util.js'
    export default {
        name: 'reldemonstrativoresultados',
        components:{
            'breadcrumb' : BreadCrumb,
            'graficobarraagrupada' : Graficobarraagrupada,
        },
        data: function() {
            return { 
                utodasfiliais       : this.$store.state.usuario.todasfiliais,
                filiaisusuario      : '',
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),
                //pidfilial           : null,
                plstfilial          : [],
                pidconta            : null,
                pidgrupoconta       : null,
                pidcentrocusto      : null,
                pdetalhartodos      : false,
                pdetalharfilial     : false,


                pexibegrafico   : false,
                
                vagrupamento    : [],
                vseries         : [],

                lstreceitas     : [],        
                lstdespesas     : [],
                totalreceitas   : 0,
                totaldespesas   : 0,  
                totaldif        : 0,
                totalreceber      : 0,
                totalrecebido     : 0,    


                ///detalhado por filial
                lstdadosfiliais : [],

                pfiltro          : 0,
                vfilialpesq      : '',
                lstfiliais      : [],




                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },                
                itensbc : {
                    item1 : {
                        titulo : 'DEMONSTRATIVO DE RESULTADOS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                }                
            }
        },
        methods:{   
            mtdbuscarfiliais() {
                let vself = this;

                $('#mdincluirfilial').modal('show');

                vself.mtdConsultaFiliais();
            },

            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.vfilialpesq === '' ? '' : ' and f.codfil='+this.vfilialpesq;
                }else{
                    rfiltro = this.vfilialpesq === '' ? '' : ' and upper(f.fantasia) like upper("'+this.vfilialpesq+'%")';
                }
                return rfiltro;
            },
            mtdConsultaFiliais(){
                let vself = this;
                let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';       
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'limit',        valor : 999999},
                    {parametro: 'offset',       valor : 0},
                    {parametro: 'sqlini',       valor : sqliniusuario},
                    {parametro: 'sqlfim',       valor : sqlfimusuario},
                ];
                let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                return retorno.then(function (response) {
                    vself.lstfiliais = response.data.filter(f => !vself.plstfilial.includes(String(f.codfil)));
                    loader.hide();
                }).catch(function () {
                    vself.lstfiliais = [];
                    loader.hide();
                });
            },
            mtdadicionafiliais() {
                let vself = this;

                // Filiais marcadas no modal
                let novasSelecionadas = vself.lstfiliais
                    .filter(f => f.selecionado)
                    .map(f => ({ codfil: f.codfil, descfil: f.descfil }));

                if (novasSelecionadas.length === 0) {
                    $.alert('Selecione pelo menos uma filial.');
                    return;
                }

                // Valores atuais do select2 (já selecionados antes)
                let $select = $('#cbfilial');
                let jaSelecionadas = $select.val() || [];

                // Concatena as novas, removendo duplicadas
                let todas = [...jaSelecionadas];
                novasSelecionadas.forEach(f => {
                    if (!todas.includes(String(f.codfil))) {
                        todas.push(String(f.codfil));
                        // Cria a opção se não existir
                        if ($select.find(`option[value="${f.codfil}"]`).length === 0) {
                            let option = new Option(f.descfil, f.codfil, true, true);
                            $select.append(option);
                        }
                    }
                });

                // Atualiza o select2 e o v-model
                $select.val(todas).trigger('change');
                vself.plstfilial = todas;

                // Fecha o modal
                $('#mdincluirfilial').modal('hide');
            },
            mtddetalhalancamentosfil(movimento, filial) {
                // monta a query string

                let fil = {
                    id  : filial.codfil,
                    text: filial.fantasia
                }


                let filiaisFormatadas = [fil];
                 

                const query = new URLSearchParams({
                    idplanoconta: movimento.idplanoconta,
                    descplanoconta: movimento.descplano,
                    pdtini : this.pdtini,
                    pdtfim : this.pdtfim,
                    filiais: JSON.stringify(filiaisFormatadas)
                }).toString();

                // monta a url com query
                const url = this.$router.resolve({
                    name: 'cadlancamentosfluxo'
                }).href + '?' + query;

                // abre em nova aba
                window.open(url, '_blank');
            },
            mtddetalhalancamentos(movimento) {
                // monta a query string

                const selecionadas = $('#cbfilial').select2('data'); // pega os dados completos (id + text)
                
                // Mapeia apenas o necessário: id e texto
                const filiaisFormatadas = selecionadas.map(f => ({
                    id: f.id,
                    text: f.text
                }));

                const query = new URLSearchParams({
                    idplanoconta: movimento.idplanoconta,
                    descplanoconta: movimento.descplano,
                    pdtini : this.pdtini,
                    pdtfim : this.pdtfim,
                    filiais: JSON.stringify(filiaisFormatadas)
                }).toString();

                // monta a url com query
                const url = this.$router.resolve({
                    name: 'cadlancamentosfluxo'
                }).href + '?' + query;

                // abre em nova aba
                window.open(url, '_blank');
            },

            mtdlimparlistagem(){
                this.lstdadosfiliais = [];
                this.lstdespesas     = [];
                this.lstreceitas     = [];
            },
            mtdimprimir(excel) {
                let vself = this;
                let exportaexcel = excel ? 1 : 0;
                
                let det = vself.pdetalharfilial ? '1' : '0';
                let dtini = util.InverterData(vself.pdtini);
                let dtfim = util.InverterData(vself.pdtfim);
                let filial = '';

        
                let selecionadas = $('#cbfilial').select2('data');
                filial = vself.plstfilial.length == 0
                    ? 'TODAS AS FILIAIS'
                    : (selecionadas.length === 1
                        ? selecionadas[0].text
                        : selecionadas.map(item => item.text).join(', '));

                vself.mtdgerartotalizadores();
                let totalizadores = {
                    totreceitas  : vself.totalreceitas,
                    totdespesas  : vself.totaldespesas,
                    totdiferenca : vself.totaldif,
                }

                let lstdadosfiliaisobjeto = {
                    receitas        : vself.lstreceitas,
                    totalreceitas   : vself.totalreceitas,
                    despesas        : vself.lstdespesas,
                    totaldespesas   : vself.totaldespesas,
                    totaldif        : vself.totaldif,
                    totalreceber    : vself.totalreceber,
                    totalrecebido   : vself.totalrecebido
                };
                let parametros = [
                    {parametro: 'op',                   valor: 'demonstrativoresultadosimpressao'},
                    {parametro: 'idclientesac',         valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'dadosdemonstrativo',   valor: vself.pdetalharfilial ? JSON.stringify(vself.lstdadosfiliais) : JSON.stringify(lstdadosfiliaisobjeto)},
                    {parametro: 'totalizadores',        valor: JSON.stringify(totalizadores)},
                    {parametro: 'detalharfil',          valor: det},
                    {parametro: 'dtini',                valor: dtini},
                    {parametro: 'dtfim',                valor: dtfim}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtrelatorios.php');
                retorno.then(function(response) {
                    if (response.data) {
                        window.open(vself.$store.state.configpaths.pathcontrole+'rtrelatorios.php?idclientesac='+
                                    vself.$store.state.filialpadrao.idcliente+
                                    '&oprelatorio=16'+
                                    '&dtini='+dtini+
                                    '&dtfim='+dtfim+
                                    '&filial='+filial+
                                    '&detalhar='+det+
                                    '&excel='+exportaexcel+
                                    '&usuario='+vself.$store.state.usuario.nome, '_blank');
                    }
                }).catch(function(response) {
                    loader.hide();
                    vself.$toastr.e('Ocorreu um erro ao gerar o relatório.', 'Erro!');
                });
            },
            mtdprocessaresposta(resp){

                this.lstdespesas = [];
                this.lstreceitas = [];

                let resposta = resp

                let dados = JSON.parse(JSON.stringify(resposta));
                this.lstdadosfiliais = []
                this.lstdadosfiliais       = JSON.parse(JSON.stringify(dados));

                console.log(this.lstdadosfiliais);


                this.mtdgerartotalizadores();
            },
            mtdmarcadesmarcafilial(array, index){
                let receitas      = array[index].receitas;
                let despesas      = array[index].despesas;
                let marcatudo     =  false;

                if(parseInt(array[index].marcado)===0){
                    marcatudo = true
                    array[index].marcado = 1;
                }else{
                    marcatudo = false;
                    array[index].marcado = 0;
                }
                   
                for (let i = 0; i < despesas.length; i++) {//despesas

                   if(marcatudo){
                        despesas[i].marcado = 1;
                   }else{
                        despesas[i].marcado = 0;
                   }

                   let movdespesas = despesas[i].movimentos
                   for (let imd = 0; imd < movdespesas.length; imd++) {//movimentos
                        if(marcatudo){
                            movdespesas[imd].marcado = 1;
                        }else{
                            movdespesas[imd].marcado = 0;
                        }
                   }                    
                }
                for (let j = 0; j < receitas.length; j++) {//receitas
                   if(marcatudo){
                        receitas[j].marcado = 1;
                   }else{
                        receitas[j].marcado = 0;
                   }
                   let movreceitas = receitas[j].movimentos
                   for (let imr = 0; imr < movreceitas.length; imr++) {//movimentos
                        if(marcatudo){
                            movreceitas[imr].marcado = 1;
                        }else{
                            movreceitas[imr].marcado = 0;
                        }
                   }        
                }
                this.mtdgerartotalizadores();
            },
            mtdmarcadesmarcamovimento(array, index){
                if(parseInt(array[index].marcado) === 1){
                    array[index].marcado = 0;
                }else{
                    array[index].marcado = 1;
                }  
                this.mtdgerartotalizadores();
            },
            mtdmarcadesmarcagrupo(array, index){
                
                let mov      = array[index].movimentos
                let marcado  = parseInt(array[index].marcado); //se tiver marcado: desmarcar e vice versa 

                if(marcado === 1){
                    for (let i = 0; i < mov.length; i++) {
                        mov[i].marcado = 0;
                    }
                    array[index].marcado = 0
                }else{
                    for (let i = 0; i < mov.length; i++) {
                        mov[i].marcado = 1;
                    }
                    array[index].marcado = 1;
                }
                this.mtdgerartotalizadores();  
            },
            mtdgerartotalizadores(){
                this.totalreceitas = 0;
                this.totaldespesas = 0;
                if(this.pdetalharfilial){
                    for (let indexfil = 0; indexfil < this.lstdadosfiliais.length; indexfil++) {
                        let receitas = this.lstdadosfiliais[indexfil].receitas;
                        let despesas = this.lstdadosfiliais[indexfil].despesas;
                        let totalreceitasfil = 0
                        let totaldespesasfil = 0

                        for (let ind    = 0; ind < receitas.length; ind++) { //receitas
                            let movreceitas       = receitas[ind].movimentos
                            let totalmovreceitas  = 0;

                            for (let i = 0; i < movreceitas.length; i++) {
                                if(parseInt(movreceitas[i].marcado)===1){
                                    totalreceitasfil = totalreceitasfil + movreceitas[i].totalmov;
                                    totalmovreceitas = totalmovreceitas + movreceitas[i].totalmov;
                                }
                            }
                            receitas[ind].totalmov = parseFloat(totalmovreceitas);
                        }
                        for (let inddesp    = 0; inddesp < despesas.length; inddesp++) { //despesas
                            let movdespesas         = despesas[inddesp].movimentos
                            let totalmovdespesas    = 0;

                            for (let j = 0; j < movdespesas.length; j++) {
                                if(parseInt(movdespesas[j].marcado)===1){
                                    totaldespesasfil = totaldespesasfil + movdespesas[j].totalmov
                                    totalmovdespesas = totalmovdespesas + movdespesas[j].totalmov;
                                }
                            }
                            despesas[inddesp].totalmov = parseFloat(totalmovdespesas);
                        }

                        this.lstdadosfiliais[indexfil].totaldespesas = parseFloat(totaldespesasfil);
                        this.lstdadosfiliais[indexfil].totalreceitas = parseFloat(totalreceitasfil);

                        this.totalreceitas = this.totalreceitas + totalreceitasfil;
                        this.totaldespesas = this.totaldespesas + totaldespesasfil;
                    }
                    this.totaldif              = parseFloat(this.totalreceitas) - parseFloat(this.totaldespesas);
                }else{
                    for (let ind    = 0; ind < this.lstreceitas.length; ind++) { //receitas
                        let movreceitas = this.lstreceitas[ind].movimentos
                        let totalmov    = 0;

                        for (let i = 0; i < movreceitas.length; i++) {
                           if(parseInt(movreceitas[i].marcado)===1){
                              this.totalreceitas = this.totalreceitas + movreceitas[i].totalmov;
                              totalmov = totalmov + movreceitas[i].totalmov;
                           }
                        }
                        this.lstreceitas[ind].totalmov = parseFloat(totalmov);
                    }
                    for (let index    = 0; index < this.lstdespesas.length; index++) { //despesas
                        let movdespesas         = this.lstdespesas[index].movimentos
                        let totalmovdespesas    = 0;

                        for (let j = 0; j < movdespesas.length; j++) {
                            if(parseInt(movdespesas[j].marcado)===1){
                                this.totaldespesas = this.totaldespesas + movdespesas[j].totalmov
                                totalmovdespesas = totalmovdespesas + movdespesas[j].totalmov;
                            }
                        }
                        this.lstdespesas[index].totalmov = parseFloat(totalmovdespesas);
                    }
                    this.totaldif              = parseFloat(this.totalreceitas) - parseFloat(this.totaldespesas);
                }
            },
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},                     
            mtddefinicoesiniais(){
                let vself    = this;

                let retm     = util.pri_ult_diames(new Date, true);
                vself.pdtini = retm.primeirodiames;
                vself.pdtfim = retm.ultimodiames;

				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                                

				let sqliniconta = 'select * from tbcontasfluxocaixa ';
				let sqlfimconta = vself.filiaisusuario !== '' ? 'where upper(descricao) like upper("%@@%") and idfilial in ('+vself.filiaisusuario+')' : 'where upper(descricao) like upper("%@@%")';                                                

				$("#cbfilial").select2({
                    multiple: true, // Permite múltiplas seleções
                    placeholder: 'Selecione 1 ou mais filiais',
                    allowClear: true,
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.plstfilial = $("#cbfilial").val();
				});

                $("#cbconta").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2sql,						
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q		: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    sqlini	: sqliniconta,
                                    sqlfim	: sqlfimconta,
                                    cpid	: 'id',
                                    cpdesc	: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidconta = $("#cbconta").val();
                });                
                $("#cbgrupoconta").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgruposcontas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidgrupoconta = $("#cbgrupoconta").val();
                });                                      
                $("#cbcentrocusto").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbcentroscustos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidcentrocusto = $("#cbcentrocusto").val();
                });            
            
            },
            mtdexecutapesquisa(){
                let vself  = this;
				if (vself.plstfilial.length === 0 && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let loader = vself.$loading.show();
                vself.pdetalhartodos = false;
                let filtro          = ' and mf.dtlancamento between "'+util.InverterData(vself.pdtini)+'" and "'+util.InverterData(vself.pdtfim)+'"';            
                if (vself.plstfilial.length > 0){
                    let stringfilial = vself.plstfilial.join(',');
                    filtro = filtro + ' and cf.idfilial in ('+stringfilial+')';
                }                
                if (vself.pidconta !==  null){
                    filtro = filtro + ' and mf.idconta=' + vself.pidconta;
                }
                if (vself.pidgrupoconta !== null){
                    filtro = filtro + ' and mf.idgrupoconta='+vself.pidgrupoconta;
                }            
                if (vself.pidcentrocusto !== null){
                    filtro = filtro + ' and mf.idcentrocusto='+vself.pidcentrocusto;
                }                
                let parametros = [
                    {parametro: 'op',           valor: 'demonstrativoresultados'},
                    {parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor: filtro},
                    {parametro: 'detalharfil',  valor: vself.pdetalharfilial ? 1 : 0},
                    {parametro: 'dtini',        valor: util.InverterData(vself.pdtini)},
                    {parametro: 'dtfim',        valor: util.InverterData(vself.pdtfim)}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    loader.hide();
                    
                    if(vself.pdetalharfilial){
                        vself.mtdprocessaresposta(response.data)
                    }else{
                        vself.lstreceitas           = response.data.receitas;
                        vself.totalreceitas         = response.data.totalreceitas;
                        vself.lstdespesas           = response.data.despesas;
                        vself.totaldespesas         = response.data.totaldespesas;
                        vself.totaldif              = parseFloat(vself.totalreceitas) - parseFloat(vself.totaldespesas);
                        vself.totalreceber          = response.data.totalreceber;
                        vself.totalrecebido         = response.data.totalrecebido;
                    }
                    if(vself.pexibegrafico){
                        vself.mtdexecutadash();
                    }
                    
                    
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdexecutadash(){
                let vself  = this;
                if(!vself.pexibegrafico){
                    return;
                }
				if (vself.plstfilial.length === 0 && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let loader = vself.$loading.show();
                vself.pdetalhartodos = false;
                let filtro          = ' and mf.dtlancamento between "'+util.InverterData(vself.pdtini)+'" and "'+util.InverterData(vself.pdtfim)+'"';            
                if (vself.plstfilial.length > 0){
                    let stringfilial = vself.plstfilial.join(',');
                    filtro = filtro + ' and cf.idfilial in ('+stringfilial+')';
                }                
                if (vself.pidconta !==  null){
                    filtro = filtro + ' and mf.idconta=' + vself.pidconta;
                }
                if (vself.pidgrupoconta !== null){
                    filtro = filtro + ' and mf.idgrupoconta='+vself.pidgrupoconta;
                }            
                if (vself.pidcentrocusto !== null){
                    filtro = filtro + ' and mf.idcentrocusto='+vself.pidcentrocusto;
                }                
                let parametros = [
                    {parametro: 'op',           valor: 'graficodemonstrativo'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor: filtro},
                    {parametro: 'idfilial',     valor: JSON.stringify(vself.plstfilial)},
             
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
                retorno.then(function (response) {
                    loader.hide();

                    let agrupamento =  response.data.agrupamento;
                    vself.vagrupamento = []
                    agrupamento.forEach(item => {
                        vself.vagrupamento.push(item.name);
                    });
                    vself.vseries = response.data.series
                
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtddetalheitem(lstitens, indice){
                if (parseInt(lstitens[indice].detalhar) === 0){
                    lstitens[indice].detalhar = 1;                
                }else{
                    lstitens[indice].detalhar = 0;                
                }
            },
            mtddetalhartodos(){
                let vself = this;
        
                if(vself.pdetalharfilial){

                    for (let index = 0; index < vself.lstdadosfiliais.length; index++) {
                        let despesas = vself.lstdadosfiliais[index].despesas;
                        let receitas = vself.lstdadosfiliais[index].receitas;

                        for (let j = 0; j < despesas.length; j++) {
                            despesas[j].detalhar = vself.pdetalhartodos === false ? 0 : 1;
                        }
                        for (let y = 0; y < receitas.length; y++) {
                            receitas[y].detalhar = vself.pdetalhartodos === false ? 0 : 1;
                        }       
                    }
                }else{
                    for (let i = 0; i < vself.lstreceitas.length; i++) {
                        vself.lstreceitas[i].detalhar = vself.pdetalhartodos === false ? 0 : 1;                
                    }
                    for (let x = 0; x < vself.lstdespesas.length; x++) {
                        vself.lstdespesas[x].detalhar = vself.pdetalhartodos === false ? 0 : 1;                
                     
                    }    
                }                        
            },        
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.filiaisusuario = response.data.filiaisusuario;
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                     
                    if (util.opcaousuario('035Z.020Z', vself.$store.state.perfilusuario)) {
                        vself.mtddefinicoesiniais();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }            
        },
        computed:{
            lstfiliaisFiltradas() {
                // Se não tiver busca, mostra todas
                if (!this.vfilialpesq) return this.lstfiliais;

                let termo = this.vfilialpesq.toUpperCase();

                if (parseInt(this.pfiltro) === 0) {
                    // Filtro por código
                    return this.lstfiliais.filter(f =>
                        String(f.codfil).includes(this.vfilialpesq)
                    );
                } else {
                    // Filtro por nome
                    return this.lstfiliais.filter(f =>
                        f.fantasia && f.fantasia.toUpperCase().includes(termo)
                    );
                }
            }
        },
        watch:{           
        }
    }
</script>
<style>
    .table-dre tr td{
        padding-top: 10px;
        padding-bottom: 10px;
    }
    #tbreceitas tr:first-child td {
        border-top: 0px!important;        
    }      
    .table-dre tr:last-child td {
        padding-bottom: 0px;        
    }
    /* .card{
        margin-top: 10px;
        border-radius: 5px;
        box-shadow: 1px 1px 5px #aaaaaa;
    } */
    .card-body{
        padding: 15px 15px 5px 15px;
    } 
    .card-title{
        color: #6c757d;
        font-weight: 600;
    }
    .icon-title{
        background: #6169d0;
        padding: 5px;
        border-radius: 5px;
        color: white; 
        width: 30px;
        text-align: center;               
    }
    .card-text{
        font-size: 26px;
        font-weight: bolder;
        color: #757575;
        padding-left: 5px;
    }
    .receitas{
        font-size: 22px;
        cursor: pointer;
        color: #0acf97;    
    }
    .despesas{
        font-size: 22px;
        cursor: pointer;
        color: #fa5c7c; 
    }
    .text-receitas{
        color: #0acf97;    
    }
    .text-despesas{
        color: #fa5c7c; 
    }    
    .receitas:hover, .despesas:hover{
        filter: brightness(70%)!important;
    }
    @media (max-width: 767px) {
        .dv-ajustar{
            margin-top: 15px;
            margin-bottom: 15px;
        }
    }
    @media (max-width: 576px) {

        .grafico-line .echarts{
            width: 300px;
            height: 250px;        
        }        
    }  
    @media (min-width: 577px) {
     
        .grafico-line .echarts{
            width: 550px;
            height: 220px;        
        }        
    }  
    @media (min-width: 1024px) {
        
        .grafico-line .echarts{
            width: 1024px;
            height: 400px;        
        }        
    }
</style>